/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, August 2020
 */

import React, { useCallback, useEffect, useReducer } from 'react';
import { Trans } from 'react-i18next';
import { FaTimes } from 'react-icons/fa';
import {
  Box,
  Link,
  Paragraph,
  styled,
  Theme,
} from '@staffino/primitive-controls';
import BodyPortal from './body-portal';

const Container = styled(Box)((props: { theme?: Theme }) => ({
  position: 'fixed' as const,
  backgroundColor: props.theme.colors.notification,
  padding: '2.5rem',
  top: 0,
  left: 0,
  right: 0,
}));

const CloseButton = styled(Box)({
  position: 'absolute',
  padding: '0.5rem',
  top: '0',
  right: '0',
  color: 'white',
});

type Props = {
  error: string | Error;
  timeout?: number;
  onClose?: () => void;
};
const ErrorDialog = ({ error, timeout = 10, onClose }: Props) => {
  const [remaining, tick] = useReducer((x) => x - 1, timeout);
  const handleTimer = useCallback(() => {
    tick();
    if (remaining === 1) {
      onClose?.();
    }
  }, [onClose, remaining]);
  useEffect(() => {
    const timer = setInterval(handleTimer, 1000);
    return () => {
      clearInterval(timer);
    };
  }, [handleTimer]);

  const message =
    typeof error === 'string' ? error : error.message || error.toString();

  return (
    <BodyPortal>
      <Container alignItems="center">
        <CloseButton>
          <Link onClick={() => onClose()}>
            <FaTimes />
          </Link>
        </CloseButton>
        <Paragraph color="white" fontWeight="bold" flexShrink={1}>
          <Trans>There was an error submitting your feedback</Trans>
        </Paragraph>
        <Paragraph color="white" flexShrink={1}>
          {message}
        </Paragraph>
      </Container>
    </BodyPortal>
  );
};

export default ErrorDialog;
